import React from "react"
import { MuiPickersUtilsProvider, KeyboardTimePicker, KeyboardDatePicker } from "@material-ui/pickers"
import { ChevronRight, ChevronLeft } from "@material-ui/icons"
import { makeStyles, useTheme } from "@material-ui/core"
import moment from "moment"
import MomentUtils from "@date-io/moment"
import { DATE_PICKER_FORMAT } from "../../../utils"

const useStyles = makeStyles((theme) => ({
	root: {
		"& .MuiSvgIcon-root": {
			color: theme.palette.primary.main,
			fill: theme.palette.primary.main,
		},
		"& .MuiTextField-root": {
			width: "100%",
		},
	},
}))

const DatePicker = ({
	date = new Date(),
	setDate,
	format = DATE_PICKER_FORMAT,
	variant = "outlined",
	label = "Select Date",
	classNames = "",
	isClearDate = false,
	...props
}) => {
	const classes = useStyles()
	const theme = useTheme()

	const clearDateProps = isClearDate ? { disabled: true, style: { display: "none" } } : {}

	return (
		<div className={classes.root}>
			<MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
				<KeyboardDatePicker
					disableToolbar
					autoOk={true}
					inputVariant={variant}
					variant="inline"
					format={format}
					margin="normal"
					id={`date-picker-${label?.trim()?.split(" ")?.join("-") || "Select-Date"}`}
					label={label}
					value={date}
					onChange={setDate}
					className={`${classNames}`}
					leftArrowIcon={<ChevronLeft style={{ color: theme.palette.text.primary }} />}
					rightArrowIcon={<ChevronRight style={{ color: theme.palette.text.primary }} />}
					KeyboardButtonProps={{
						"aria-label": "change date",
						...clearDateProps,
					}}
					{...props}
				/>
			</MuiPickersUtilsProvider>
		</div>
	)
}

export default DatePicker
